import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import "flatpickr/dist/plugins/monthSelect/style.css";

export default function PayoutReport() {
  const [reportData, setReportData] = useState(null);
  const [filterValues, setFilterValues] = useState({
    staffId: "00000000-0000-0000-0000-000000000000",
    month: new Date(),
  });
  const [staffs, setStaffs] = useState([]);
  const [errors, setErrors] = useState({});
  const userId = localStorage.getItem("userId");
  const headerconfig = {
    headers: { Authorization: "Bearer " + localStorage.getItem("userToken") },
  };

  const handleClear = () => {
    setFilterValues({
      staffId: "00000000-0000-0000-0000-000000000000",
      month: new Date(),
    });
    setReportData(null);
  };

  const handleSearch = () => {
    GetData();
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterValues({
      ...filterValues,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    GetData();
  };

  const GetData = () => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETPAYOUTREPORT +
          "?staffId=" +
          filterValues.staffId +
          "&month=" +
          moment(filterValues.month).format("YYYY-MM"),
        { ...headerconfig }
      )
      .then((response) => {
        setReportData(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching payout report:", error);
        setReportData(null);
      });
  };
  const GetStaffs = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETALLSTAFFS + "?userId=" + userId, {
        ...headerconfig,
      })
      .then((response) => {
        setStaffs(response.data.data);
      });
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    GetStaffs();
  }, []);

  const formatOvertimeHours = (hours) => {
    if (!hours) return "0h 0m";
    const h = Math.floor(hours);
    const m = Math.round((hours % 1) * 60);
    return `${h}h ${m}m`;
  };

  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <LayoutSideBar></LayoutSideBar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Payout Report</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                  <div className="col-lg-3">
                    <label>Staff</label>
                    <select
                      name="staffId"
                      value={filterValues.staffId}
                      onChange={handleFilterChange}
                      className="form-select"
                    >
                      <option value="00000000-0000-0000-0000-000000000000">
                        All
                      </option>
                      {staffs.map((s) => (
                        <option key={s.staffId} value={s.staffId}>
                          {s.staffName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-3">
                    <label>Month</label>
                    <div className="input-group">
                      <Flatpickr
                        value={filterValues.month}
                        className="form-control"
                        options={{
                          dateFormat: "Y-m",
                          maxDate: new Date(),
                          plugins: [
                            new monthSelectPlugin({
                              shorthand: true,
                              dateFormat: "M-Y",
                              theme: "light",
                            }),
                          ],
                        }}
                        onChange={(date) =>
                          setFilterValues({ ...filterValues, month: date[0] })
                        }
                      />
                      <div className="input-group-text bg-primary border-primary text-white">
                        <i className="ri-calendar-2-line" />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="hstack gap-2 justify-content-middle mb-3 mt-4">
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={handleClear}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th>Staff</th>
                            <th>Total Working Days</th>
                            <th>Attended Days</th>
                            <th>Overtime Hours</th>
                            <th>Actual Amount</th>
                            <th>Eligible Amount</th>
                            <th>Overtime Amount</th>
                            <th>Total Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reportData ? (
                            <tr>
                              <td>{reportData.staffName}</td>
                              <td>{reportData.totalWorkingDays}</td>
                              <td>{reportData.attendedDays}</td>
                              <td>
                                {formatOvertimeHours(reportData.overtimeHours)}
                              </td>
                              <td>{reportData.actualAmount}</td>
                              <td>{Math.round(reportData.eligibleAmount)}</td>
                              <td>{reportData.overtimeAmount}</td>
                              <td>{Math.round(reportData.totalAmount)}</td>
                            </tr>
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No Data Available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
